import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tabs, Button } from "antd";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import SellDialog from "./SellDialog";
import EarningDetailsDialog from "./EarningDetailsDialog";

const { TabPane } = Tabs;

const ProductDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const category_id = state?.category_id;
  const product = state?.product;

  const parsedData = JSON.parse(product.data);

  const [sellModalVisible, setSellModalVisible] = useState(false);

  const [earningModalVisible, setEarningModalVisible] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);

  const showEarningDetails = (product) => {
    setModalProduct(product);
    setEarningModalVisible(true);
  };

  return (
    <div className="bg-light min-vh-100">
      <Header />

      <div className="bg-light py-5 px-3  d-flex align-items-center justify-content-center">
        <div
          className="card  rounded-4 w-100"
          style={{ maxWidth: "1200px", minHeight: "800px" }}
        >
          <div className="card-body p-4">
            {/* Back Button (above the title) */}
            <Button
              type="default"
              onClick={() => navigate(-1)}
              style={{ borderRadius: "8px", backgroundColor: "#f5f5f5" }}
            >
              ← Back
            </Button>

            {/* Product Info */}
            <div className="text-center mb-5">
              <div
                className="mx-auto d-flex align-items-center justify-content-center mb-3"
                style={{
                  height: "100px",
                  width: "100px",
                  borderRadius: "12px",
                  backgroundColor: "#f1f3f5",
                  border: "1px solid #e0e0e0",
                }}
              >
                <img
                  src={product.logo}
                  alt={product.name}
                  style={{
                    maxHeight: "60px",
                    maxWidth: "80px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <h2 className="fw-bold">{product.name}</h2>
              <p className="text-muted">{product.sub_title}</p>

              {/* Earn Upto Badge */}
              <div className="mb-3">
                <span
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent card click
                    showEarningDetails(product);
                  }}
                  className="px-3 py-1 rounded-pill text-white fw-medium"
                  style={{
                    backgroundColor: "#28a745",
                    fontSize: "16px",
                    marginRight: "8px",
                  }}
                >
                  Earn up to{" "}
                  {product.payout_type === "FLAT"
                    ? `₹${(
                        parseFloat(product.amount || 0) +
                        parseFloat(product.bonus_amount || 0)
                      ).toFixed(2)}`
                    : `${(
                        parseFloat(product.amount || 0) +
                        parseFloat(product.bonus_amount || 0)
                      ).toFixed(2)}%`}
                </span>

                {/* Info Icon - outside badge */}
                <InfoCircleOutlined
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent card click
                    showEarningDetails(product);
                  }}
                  style={{
                    fontSize: "16px",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "50%",
                    padding: "3px",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Sell Now Button (Full Width) */}
              <button
                className="btn btn-primary w-100 rounded-pill mt-2"
                onClick={(e) => {
                  e.stopPropagation(); // prevent parent onClick
                  setSellModalVisible(true);
                }}
              >
                Sell Now
              </button>
            </div>

            {/* Tabs */}
            <Tabs
              defaultActiveKey="0"
              centered
              type="card"
              tabBarStyle={{}}
              className="custom-tabs"
            >
              {parsedData.tabs.map((tab, index) => (
                <TabPane tab={tab.tabName} key={index}>
                  {tab.content.map((section, idx) => (
                    <div key={idx} className="mb-5">
                      <h5 className="fw-semibold border-bottom pb-2">
                        {section.title}
                      </h5>
                      <ul
                        className="ps-3 mt-2"
                        style={{ listStyle: "none", paddingLeft: 0 }}
                      >
                        {Array.isArray(section.content)
                          ? section.content.map((line, i) => (
                              <li key={i} className="mb-2 text-secondary">
                                {line}
                              </li>
                            ))
                          : null}
                        {/* {section.content ||
                        {}.map((line, i) => (
                          <li key={i} className="mb-2 text-secondary">
                            {line}
                          </li>
                        ))} */}
                      </ul>
                    </div>
                  ))}
                </TabPane>
              ))}
            </Tabs>
          </div>
        </div>

        <SellDialog
          open={sellModalVisible}
          onClose={() => setSellModalVisible(false)}
          category_id={category_id}
          product={product}
        />

        <EarningDetailsDialog
          open={earningModalVisible}
          onClose={() => setEarningModalVisible(false)}
          product={modalProduct}
        />
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetails;
